import * as React from 'react';

import { DirsTemplatesInner, IDirsTemplatesInnerProperties } from './DirsTemplatesInner';

export function DirsTemplates(props: IDirsTemplatesInnerProperties) {
    return (
        <div className="popup-dirs popup-overflow-controled">
            <DirsTemplatesInner {...props} />
            <div className="modal-backdrop fade show"></div>
        </div>
    );
}
